import http from "../HttpService";
import { API_BASE_URL_ENV } from "helpers/common";
import axios from "axios";

const apiEndpoint = API_BASE_URL_ENV() + "/users/login";
const apiLogoutEndpoint = API_BASE_URL_ENV() + "/users/logout";
const regsiterApiEndpoint = API_BASE_URL_ENV() + "/users/register";
const verifyApiEndpoint = API_BASE_URL_ENV() + "/users/verify";
const ProfileApiEndpoint = API_BASE_URL_ENV() + "/website/user/profile";
export const tokenKey = "vr_token";

http.setJwt(getJwt());

//TODO refactor duplication
export async function login(credentials) {
	const { data: userData } = await http.post(apiEndpoint, credentials);
	if (userData?.status === 200) {
		localStorage.setItem(tokenKey, userData?.data?.accessToken);
		localStorage.setItem(
			"vr_auth",
			JSON.stringify({
				...userData?.data?.user,
				token: userData?.data?.accessToken,
				userType: "user",
			}),
		);
		http.setJwt(userData?.data?.accessToken);
	}
	return userData;
}
export async function logoutFn() {
	const { data: userData } = await http.post(apiLogoutEndpoint);
	return userData;
}

export async function register(credentials) {
	const { data: userData } = await http.post(regsiterApiEndpoint, credentials);
	return userData;
}
export async function verify(credentials) {
	const { data: userData } = await http.post(verifyApiEndpoint, credentials);
	if (userData?.data?.accessToken) {
		localStorage.setItem(tokenKey, userData.data.accessToken);
		localStorage.setItem(
			"vr_auth",
			JSON.stringify({
				...userData.data,
				token: userData?.data?.accessToken,
				userType: "user",
			}),
		);
	}
	return userData;
}
export async function forgetPassword(credentials) {
	const { data: userData } = await http.put(
		`${API_BASE_URL_ENV()}/users/forgetPassword`,
		credentials,
	);
	return userData;
}

export async function verifyForgetPasswordCode(credentials) {
	const { data: userData } = await http.put(
		`${API_BASE_URL_ENV()}/users/verifiedForgetPasswordCode`,
		credentials,
	);
	return userData;
}

export async function changePasswordForForget(credentials, token) {
	const { data: userData } = await http.put(
		`${API_BASE_URL_ENV()}/users/changePasswordForForgetPassword`,
		credentials,
		token ? { headers: { Authorization: `${token}` } } : undefined,
	);
	return userData;
}

export async function resetPassword(url, params) {
	const data = await http.post(url, params);
	return data;
}

export async function changePassword(url, params) {
	const { data: userData } = await http.post(url, params);
	return userData;
}

export function loginWithJwt(jwt) {
	localStorage.setItem(tokenKey, jwt);
}

export function logout() {
	localStorage.removeItem(tokenKey);
	localStorage.removeItem("vr_auth");
}

export async function getCurrentUser() {
	try {
		http.setJwt(getJwt());
		// const jwt = localStorage.getItem(tokenKey);
		const { data: userData } = await http.get(ProfileApiEndpoint);
		return userData;
		// return jwtDecode(jwt);
	} catch (ex) {
		return null;
	}
}

export function isAuthenticated() {
	return localStorage.getItem(tokenKey) ? true : false;
}

export function getJwt() {
	return localStorage.getItem(tokenKey);
}

export default {
	login,
	loginWithJwt,
	logout,
	getCurrentUser,
	getJwt,
	isAuthenticated,
	resetPassword,
	changePassword,
	register,
	forgetPassword,
	verifyForgetPasswordCode,
	changePasswordForForget,
	verify,
};
